<div
  class="tooltip"
  [class.hidden]="tooltipData.hidden"
  [style.left.px]="tooltipData.x"
  *ngIf="interactivity"
>
  <p>
    <span class="label">{{ tooltipData.date | translate }} </span>
    <span class="date">{{ tooltipData.label | translate }}</span>
  </p>
  <p class="point" *ngFor="let point of tooltipData.points">
    <span class="color" [style.background-color]="point.color"></span>
    <span class="value">{{ point.value | translate }}</span>
    <small> {{ unit | translate }}</small>
    <small> {{ point.label | translate }}</small>
  </p>
</div>
<div class="legend" *ngIf="colorScale && categories.length">
  <div
    class="legend-item"
    [class.selected]="selectedCategory === cat.value"
    *ngFor="let cat of categories; let index = index"
    [class.interactive]="interactivity"
  >
    <div
      *ngIf="!config.excludeMode"
      class="color"
      [style.background-color]="colorScale(index)"
    ></div>
    <p
      class="name"
      (click)="
        selectedCategory !== cat.value
          ? onCategorySelected(cat.value)
          : onCategorySelected(null)
      "
    >
      {{ cat.label | titlecase | translate }}
    </p>
    <button
      *ngIf="!config.excludeMode"
      class="remove-btn"
      (click)="onCategorySelected(null)"
    ></button>
  </div>
</div>
<svg #svg></svg>
